import { QuoteItemsAttributesPatchRequestBody } from '@lio/api-types';

export function getUpdateCustomerEmailAttributes({
  quoteId,
  namedInsuredItem,
  newEmail,
  customerEmailAttributeType,
}: {
  quoteId: string;
  namedInsuredItem: { id: string };
  newEmail: string;
  customerEmailAttributeType: {
    id: string;
    attribute?: { id?: string };
  };
}): Omit<QuoteItemsAttributesPatchRequestBody, 'quoteId'> & { quoteId: string } {
  const attributesArray: {
    id?: string;
    quoteItemAttributeTypeId: string;
    value: string;
    isUpdatedByUser: boolean;
  }[] = [];

  // Update CustomerEmail (even if blank)
  attributesArray.push({
    id: customerEmailAttributeType.attribute?.id,
    quoteItemAttributeTypeId: customerEmailAttributeType.id,
    value: newEmail,
    isUpdatedByUser: true,
  });

  const quoteItemAttributes = attributesArray.map((attribute) => ({
    value: attribute.value,
    id: attribute?.id,
    quoteItemAttributeTypeId: attribute.quoteItemAttributeTypeId,
    isUpdatedByUser: attribute.isUpdatedByUser,
  }));

  return {
    quoteId,
    quoteItems: [
      {
        id: namedInsuredItem.id,
        quoteItemAttributes,
      },
    ],
  };
}
